export const parseCabinetQrCode = (qrCodeString) => {
  const input = String(qrCodeString || '').trim()
  if (!input) return null

  try {
    const data = JSON.parse(input)
    const cabinetSerial = data.cabinet_serial || data.serial
    const slotPosition = parseInt(data.slot_position ?? data.slot, 10)

    if (!cabinetSerial || Number.isNaN(slotPosition)) {
      return null
    }

    return {
      cabinet_serial: cabinetSerial,
      slot_position: slotPosition,
    }
  } catch {
    const parts = input.split(',').map((part) => part.trim())
    if (parts.length !== 2) return null

    const [cabinetSerial, slotString] = parts
    const slotPosition = parseInt(slotString, 10)

    if (!cabinetSerial || Number.isNaN(slotPosition)) {
      return null
    }

    return {
      cabinet_serial: cabinetSerial,
      slot_position: slotPosition,
    }
  }
}
